import React, { useState } from 'react';
import api from '../../services/api';

export default function EarningsSummary({ symbol }) {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchSummary = async () => {
    setLoading(true);
    try {
      const { data } = await api.post('/chat/earnings-summary', { symbol });
      setSummary(data.summary || data.reply || 'No summary available');
    } catch (err) {
      // Tier-limit errors are handled globally by LimitReachedModal
      if (!err.tierDetail) {
        console.error(err);
      }
    } finally {
      setLoading(false);
    }
  };

  if (summary) {
    return <div style={{ padding: '8px 0', fontSize: '0.85rem', color: '#F1F5F9', lineHeight: 1.5 }}>{summary}</div>;
  }

  return (
    <button
      onClick={fetchSummary}
      disabled={loading}
      style={{
        padding: '6px 16px',
        fontSize: '0.78rem',
        background: 'rgba(100, 149, 237, 0.12)',
        border: '1px solid #6495ED',
        color: '#6495ED',
        borderRadius: 6,
        cursor: 'pointer',
        fontWeight: 600,
        transition: 'all 0.15s ease',
      }}
      onMouseEnter={(e) => { e.target.style.background = 'rgba(100, 149, 237, 0.25)'; }}
      onMouseLeave={(e) => { e.target.style.background = 'rgba(100, 149, 237, 0.12)'; }}
    >
      {loading ? 'Loading...' : 'Earnings Summary'}
    </button>
  );
}
